import { getUserUnitLabel, regularRound, useAppUser } from '@bechtel/client-common';
import { Box, Set, SetDirection, SetSpacing, Text } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';
import { FC } from 'react';
import { MilestoneStatusExt, MilestoneStatusExtended } from '../types';
import { MilestoneLinearFeetProps } from './types';

const getLinearFeetLabel = (
  status: MilestoneStatusExt,
  unitLabel: string,
  isFitupMilestone?: boolean,
  hasFitupRequest?: boolean,
  isFitupRequired?: boolean
) => {
  if (isFitupMilestone) return `Fitup ${unitLabel}`;

  switch (status) {
    case MilestoneStatusCode.REQUESTED:
      return `Fitup ${unitLabel}`;
    case MilestoneStatusCode.PLANNED:
    default:
      return `${unitLabel} to Earn`;
    case MilestoneStatusCode.CLAIMED:
      return hasFitupRequest ? `${unitLabel} Until Claim` : `${unitLabel} Claimed`;
    case MilestoneStatusCode.REJECTED:
      return isFitupRequired ? `${unitLabel} Rejected` : `Fitup ${unitLabel}`;
    case MilestoneStatusCode.APPROVED:
      return hasFitupRequest ? `${unitLabel} Until Approve` : `${unitLabel} Approved`;
    case MilestoneStatusExtended.BLOCKED:
      return `${unitLabel} Blocked`;
  }
};

export const MilestoneLinearFeet: FC<MilestoneLinearFeetProps> = ({
  quantity,
  status,
  isFitupMilestone,
  hasFitupRequest,
  isFitupRequired,
}) => {
  const { user } = useAppUser();
  const unitLabel = getUserUnitLabel(user);

  return (
    <Box flexDirection={{ sm: 'column' }} py={{ sm: '500' }}>
      <Set
        style={{ whiteSpace: 'nowrap' }}
        spacing={SetSpacing.COMPACT}
        direction={SetDirection.COL}
        alignItems={'center'}
      >
        <Text size="800" color="grey.1000">
          {isFitupMilestone ? '-' : regularRound(quantity.quantity, 3)}
        </Text>

        <Text size="300" color="grey.600">
          {getLinearFeetLabel(status, unitLabel, isFitupMilestone, hasFitupRequest, isFitupRequired)}
        </Text>
      </Set>
    </Box>
  );
};
